import type { FaireProductEntity } from "../../entity_types/product";

export const p_65c7zy4hch: FaireProductEntity = {
  token: "p_65c7zy4hch",
  type: "product",
  name: "Horny For Hockey Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/8bb9eb8e3b7d425e64ca174befb1c6481278eea01f035bdb27d63ac96c118f70.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3bdc2bc7c7136f83321aa5cfba0f3a0e3a4c9c220b59127bdc169350a3988909.png",
    "https://cdn.faire.com/fastly/7d3ad769bf0fecbb1600e7b416a69366c151b6ea940c1f6d75747cabe8ef8969.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/2f62218e17b99c606f1ffb962daa7f19b5d0f5408e2f4feac0312cca95d9d68f.png",
    "https://cdn.faire.com/fastly/a2be30455903fbb7275c7375d10526cc972eed6e6125efd4b36598daae290752.png"
  ],
  priceDollars: 6.75,
  description: "For those who come for the rivalry… and come again thinking about the heat. 🏒 🥅\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products—be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:33:18.847Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
